// extracted by mini-css-extract-plugin
export default {"documentsModal":"styles_documentsModal__r3jAD","documentsModalTitle":"styles_documentsModalTitle__nq1Ue"};